// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ViewMenu-viewSelector__rMJ6Y{padding:var(--size-4)}.ViewMenu-menu__y2wsD{position:relative;display:flex;flex-direction:column;min-height:0;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewSelector": "ViewMenu-viewSelector__rMJ6Y",
	"menu": "ViewMenu-menu__y2wsD"
};
export default ___CSS_LOADER_EXPORT___;
